import { MonthlyUsersResult } from "@idw-types/data/monthly-users-result/monthly-users-result";
import { resources } from "@constants/hardcoded-strings";
import styles from "./user-summary-table-container.less";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleUp } from "@fortawesome/free-solid-svg-icons/faChevronCircleUp";
import { IdwTableContainer } from "../../../common/idw-table-container/idw-table-container";

type UserSummaryTableContainerProps = {
    monthlyUsersResult: MonthlyUsersResult;
};

export const UserSummaryTableContainer = (props: UserSummaryTableContainerProps) => {
    const { monthlyUsersResult } = props;
    const [approvedTableExpanded, setApprovedTableExpanded] = useState(false);

    const toggleExpandApprovedTable = () => {
        setApprovedTableExpanded(!approvedTableExpanded);
    };

    return (
        <IdwTableContainer className={styles.userSummaryTableContainer}>
            <div className={styles.tableHeader}>{resources.tables.userSummary.title}</div>
            <table className={styles.userSummaryTable}>
                <tbody>
                    <tr>
                        <td />
                        <td>{resources.tables.userSummary.rows.totalUniqueMonthlyUsers.label}</td>
                        <td>{monthlyUsersResult.totalUsersCount}</td>
                        <td />
                    </tr>
                    <tr id="summary-table-expand-approved" onClick={toggleExpandApprovedTable}>
                        <td>
                            <FontAwesomeIcon
                                className={`${styles.chevron} ${!approvedTableExpanded && styles.rotate}`}
                                icon={faChevronCircleUp}
                                title={approvedTableExpanded
                                    ? resources.common.collapse
                                    : resources.common.expand
                                }
                            />
                        </td>
                        <td>{resources.tables.userSummary.rows.approvedUsers.label}</td>
                        <td>{monthlyUsersResult.approvedUsersCount}</td>
                        <td>{monthlyUsersResult.approvedUsersPercent}%</td>
                    </tr>
                    {approvedTableExpanded && (
                        <tr className={styles.approvedUsersTableRow}>
                            <td colSpan={4}>
                                <div className={styles.approvedUsersTableContainer}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>{resources.tables.userSummary.rows.approvedUsers.table.rows.newUsers}</td>
                                                <td>{monthlyUsersResult.newUsersCount}</td>
                                                <td>{monthlyUsersResult.newUsersPercent}%</td>
                                            </tr>
                                            <tr>
                                                <td>{resources.tables.userSummary.rows.approvedUsers.table.rows.renewedUsers}</td>
                                                <td>{monthlyUsersResult.renewedUsersCount}</td>
                                                <td>{monthlyUsersResult.renewedUsersPercent}%</td>
                                            </tr>
                                            <tr>
                                                <td>{resources.tables.userSummary.rows.approvedUsers.table.rows.returningUsers}</td>
                                                <td>{monthlyUsersResult.returningUsersCount}</td>
                                                <td>{monthlyUsersResult.returningUsersPercent}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td />
                        <td>{resources.tables.userSummary.rows.deniedUsers.label}</td>
                        <td>{monthlyUsersResult.deniedUsersCount}</td>
                        <td>{monthlyUsersResult.deniedUsersPercent}%</td>
                    </tr>
                    <tr>
                        <td />
                        <td>{resources.tables.userSummary.rows.otherUsers.label}</td>
                        <td>{monthlyUsersResult.otherUsersCount}</td>
                        <td />
                    </tr>
                </tbody>
            </table>
        </IdwTableContainer>
    );
};